import { createAction } from "@coverme/redux";
import Axios from "axios";

export const addTag = (encounterId, tag) =>
    createAction("ADD_TAG", () => {
        return Axios.post(`/api/encounter/${encounterId}/tag/${tag}`).then(data => tag);
    });

export const deleteTag = encounterId =>
    createAction("DELETE_TAG", () => {
        return Axios.delete(`/api/encounter/${encounterId}/tag`).then(data => "None");
    });

export const getEncounterTag = encounterId =>
    createAction("GET_ENCOUNTER_TAG", () => Axios.get(`/api/encounter/${encounterId}/tag`)
      .then(res => res.data));
